<template>
  <div class="page-add">
    <div class="add-title">视频集详情</div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      size="small"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group disabled v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" WEB是否展示：" required>
            <el-radio-group disabled v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" 小程序是否展示：" required>
            <el-radio-group disabled v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" PC端是否展示：" required>
            <el-radio-group disabled v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="item.paramKey"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="名称：" prop="videoSetName">
            <el-input
              placeholder="请输入视频集名称"
              v-model="ruleForm.videoSetName"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="视频分类：" prop="categoryId" required>
            <el-cascader
              class="form-select"
              v-model="ruleForm.categoryId"
              :options="videoCategoryData"
              :props="{ label: 'name', value: 'id', children: 'children' }"
              disabled
              style="width: 100%"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="视频集来源：" prop="videoSetSource" required>
          <el-select
            class="form-select"
            v-model="ruleForm.videoSetSource"
            placeholder="请选择视频集来源"
            disabled
            style="width: 100%"
          >
            <el-option
              v-for="item in videoSetSourceList"
              :key="item.paramKey"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="视频集标签：" prop="tagKeyList">
          <el-select
            multiple
            :multiple-limit="10"
            class="form-select"
            v-model="ruleForm.tagKeyList"
            placeholder="请选择视频集标签"
            disabled
            style="width: 100%"
          >
            <el-option
              v-for="item in videoTagList"
              :key="item.paramKey"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="描述：" prop="videoSetDesc">
            <el-input
              :rows="3"
              type="textarea"
              placeholder="请输入视频集描述"
              v-model="ruleForm.videoSetDesc"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="配图："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传配图',
            }"
            :show-message="showError"
          >
            <av-preview
              v-if="ruleForm.coverUrl"
              :src="ruleForm.coverUrl"
              type="image"
              :deleteable="false"
            />
            <upload
              v-else
              :draggable="false"
              :path="'videoSet/img'"
              type="image"
              v-model="ruleForm.covers"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item style="width:50%" class="scale" label="备注：" prop="remark">
            <el-input class="textarea" type="textarea" maxlength="1000" show-word-limit v-model="ruleForm.remark"
              placeholder="请输入备注" :autosize="{ minRows: 4, maxRows: 10}" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="视频列表：">
            <Table
              :class="{ 'list-drag': dragaable }"
              :data="ruleForm.videoInfoList"
              row-key="uuid"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0" class="center">
        <back-button :pathOptions="pathOptions" :floatLeft="false" />
      </el-form-item>
    </el-form>
    <el-dialog
      :visible.sync="diaVisible"
      title="视频管理"
      class="rc-dialog"
      width="700px"
    >
      <videoTran
        :data="data"
        :title="'视频'"
        :param="'videoName'"
        :renderKeys="renderKeys"
        :renderData="renderList"
        @change-sel="changeVideo"
      ></videoTran>
      <span slot="footer" class="dialog-footer">
        <el-button @click="diaVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addVideo"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import Table from "./table.js";
import videoTran from "@/components/videoTran/index";
import vue from "@/main";
import Upload from "@/components/upload/index";
import AvPreview from "@/components/av-preview/index";
import { videoSetUpdate, getNoRVideo, getVideosetInfo } from "@/api/videoSet";
import { Confirm } from "@/components/Confirm";
import rulesFactory from "@/utils/rules";
import { resCategoryTree } from "@/api/rescategory";
import { getSysParamByTypes } from "@/api/sysParam";
import { findTrackById } from "@/utils/shared";
import BackButton from "@/components/backButton/index.vue";

export default {
  components: { Table, videoTran, Upload, AvPreview, BackButton },
  data() {
    return {
      pathOptions: {
        path: "/videoSet",
      },
      ruleForm: {
        videoSetName: "",
        videoSetDesc: "",
        coverUrl: "",
        isApplet: "",
        isPc: "",
        isApp: "",
        isWeb: "",
        covers: [],
        categoryId: "",
        videoSetSource: "",
        tagKeyList: [],
      },
      data: [],
      props: {
        key: "uuid",
        label: "videoName",
      },
      diaVisible: false,
      showError: false,
      selVideo: [],
      rules: {
        videoSetName: [
          {
            required: true,
            message: "请输入视频集名称",
            trigger: ["blur", "change"],
          },
          rulesFactory.size("最多输入200个字", 0, 200),
        ],
        videoSetDesc: [
          {
            required: true,
            message: "请输入视频集描述",
            trigger: ["blur", "change"],
          },
          rulesFactory.size("最多输入200个字", 0, 200),
        ],
      },
      dragaable: false, //控制拖拽排序,
      curVideoList: [], // 穿梭框右侧选中节点
      renderList: [], // 初始选中节点
      renderKeys: [], // 初始选中节点key
      videoCategoryData: [],
      videoSetSourceList: [],
      videoTagList: [],
    };
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
    "ruleForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.ruleForm.coverUrl = val[0].url;
          this.showError = false;
        } else {
          this.ruleForm.coverUrl = "";
          this.showError = true;
        }
      },
    },
  },
  created() {
    Promise.all([
      getVideosetInfo({ uuid: this.$route.query.uuid }).then((res) => {
        if (!res || res.code != 0) return;
        this.ruleForm.categoryId = res.data.categoryId || "";
        this.ruleForm.videoSetName = res.data.videoSetName;
        this.ruleForm.videoSetDesc = res.data.videoSetDesc;
        this.ruleForm.videoInfoList = res.data.videoInfoList;
        this.ruleForm.isApplet = String(res.data.isApplet);
        this.ruleForm.isPc = String(res.data.isPc);
        this.ruleForm.isApp = String(res.data.isApp);
        this.ruleForm.isWeb = String(res.data.isWeb);
        this.ruleForm["covers"] = [{ url: res.data.coverUrl }];
        this.ruleForm.remark = res.data.remark || '';
        this.ruleForm.videoSetSource =
          ((res.data.videoSetSource || res.data.videoSetSource === 0) &&
            String(res.data.videoSetSource)) ||
          "";
        this.ruleForm.tagKeyList =
          (res.data.tagKeyList &&
            res.data.tagKeyList.map((item) => String(item))) ||
          [];
        this.originSelVideo = [];
        this.selVideo = [];
        let videoInfoList = JSON.parse(
          JSON.stringify(this.ruleForm.videoInfoList)
        );
        this.renderList = videoInfoList;
        this.getRenderKey(this.renderList);
        this.curVideoList = videoInfoList;
      }),

      resCategoryTree({
        categoryType: 0,
        display: 1,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.videoCategoryData = res.data || [];
      }),
    ])
      .then(() => {
        this.$nextTick(() => {
          if (
            this.ruleForm.categoryId &&
            this.videoCategoryData &&
            this.videoCategoryData.length
          ) {
            const track = findTrackById(
              this.videoCategoryData,
              this.ruleForm.categoryId,
              "id"
            );
            if (track && track.length) {
              this.ruleForm.categoryId = track;
            }
          }
        });
      })
      .catch((_) => _);

    this.getList();

    // 视频列表删除时同步穿梭框状态
    vue.$on("deleteVideoSet", (index) => {
      this.ruleForm.videoInfoList.splice(index, 1);
      this.renderList.splice(index, 1);
      this.getRenderKey(this.renderList);
    });
  },
  beforeDestroy() {
    vue.$off("deleteVideoSet");
  },
  computed: {
    dragDisabled() {
      if (
        this.ruleForm.videoInfoList &&
        this.ruleForm.videoInfoList.length < 2
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.videoSetSourceList = res.data["VIDEO_SOURCE"] || [];
        this.videoTagList = res.data["RECOMMEND_TAG"] || [];
        this.publicData = res.data["IS_VALID"] || [];
      });
    },
    // 接口请求
    getList() {
      this.getSysParamByTypes([
        "VIDEO_SOURCE",
        "TAG",
        "RECOMMEND_TAG",
        "VIDEO_TYPE",
        "IS_VALID",
      ]);
    },

    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 结束拖拽的时候
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            const currRow = _this.ruleForm.videoInfoList.splice(oldIndex, 1)[0];
            _this.ruleForm.videoInfoList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    showVideoManage() {
      this.diaVisible = true;
      getNoRVideo({ uuid: this.$route.query.uuid }).then((res) => {
        if (!res || res.code != 0) return;
        this.data = res.data;
      });
    },
    // 删除封面

    // 获取选中视频uuid集合
    getVideoUuids() {
      let videoInfoList = this.ruleForm.videoInfoList;
      this.ruleForm.videoUuids = [];
      if (videoInfoList && videoInfoList.length > 0) {
        for (let i = 0; i < videoInfoList.length; i++) {
          this.ruleForm.videoUuids.push(videoInfoList[i].uuid);
        }
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!this.ruleForm.coverUrl) {
          this.showError = true;
          return;
        }
        if (valid) {
          this.getVideoUuids();
          let params = { ...this.ruleForm, uuid: this.$route.query.uuid };
          if (params.categoryId) {
            params.categoryId = params.categoryId.pop();
          }
          delete params.covers;
          params["onlineStatus"] = 0;
          videoSetUpdate(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$router.back();
          });
        }
      });
    },
    reset() {
      const text = "确定重置吗?";
      Confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.showError = false;
        this.ruleForm.covers = [];
        this.$refs["ruleForm"].resetFields();
        this.ruleForm.videoInfoList = [];
      });
    },
    // 确定按钮，同步选中视频和视频列表
    addVideo() {
      this.diaVisible = false;
      this.ruleForm.videoInfoList = JSON.parse(
        JSON.stringify(this.curVideoList)
      );
      this.renderList = JSON.parse(JSON.stringify(this.curVideoList));
      this.getRenderKey(this.renderList);
    },
    // 选项改变时，赋值
    changeVideo(curRenderList) {
      this.curVideoList = curRenderList;
    },
    getRenderKey(data) {
      this.renderKeys = [];
      for (var i = 0; i < data.length; i++) {
        this.renderKeys.push(data[i].uuid);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;

.btn-right {
  text-align: right;
  margin: 32px 0 12px 0;
}
.mr16 {
  margin-right: 10px;
}
.option_rect {
  text-align: right;
  margin-bottom: 12px;
}
.center {
  text-align: center;
}
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 330px;
  }
}
</style>
